import { render, staticRenderFns } from "./RowMenuItem.vue?vue&type=template&id=9e9ec6a6"
import script from "./RowMenuItem.vue?vue&type=script&lang=js"
export * from "./RowMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports